import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import PlacesPage from "@/pages/places/page";
import RestaurantsPage from "@/pages/restaurants/page";
import ArticlesPage from "@/pages/articles/page";
import PlaceDetail from "@/pages/detail/PlaceDetail";
import RestaurantDetail from "@/pages/detail/RestaurantDetail";
import ArticleDetail from "@/pages/detail/ArticleDetail";
import RestaurantApplyPage from "@/pages/restaurant-apply/page";
import AdminPage from "@/pages/admin/page";
import ApplicationDetail from "@/pages/admin/ApplicationDetail";
import HotelApplyPage from "@/pages/hotel-apply/page";
import AccommodationsPage from "@/pages/accommodations/page";
import AccommodationDetail from "@/pages/accommodations/detail";
import GoldApplyPage from "@/pages/gold-apply/page";
import BlackSeaGuide from "@/pages/guides/BlackSeaGuide";
import DayTripsGuide from "@/pages/guides/DayTripsGuide";
import IstanbulFaq from "@/pages/city-faq/IstanbulFaq";
import KapadokyaFaq from "@/pages/city-faq/KapadokyaFaq";
import AntalyaFaq from "@/pages/city-faq/AntalyaFaq";
import IzmirFaq from "@/pages/city-faq/IzmirFaq";
import MardinFaq from "@/pages/city-faq/MardinFaq";
import TrabzonFaq from "@/pages/city-faq/TrabzonFaq";
import SakarayaFaq from "@/pages/city-faq/SakarayaFaq";
import KocaeliFaq from "@/pages/city-faq/KocaeliFaq";
import BoluFaq from "@/pages/city-faq/BoluFaq";
import GaziantepFaq from "@/pages/city-faq/GaziantepFaq";
import AnnouncementsPage from "@/pages/announcements/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/places", element: <PlacesPage /> },
  { path: "/place/:id", element: <PlaceDetail /> },
  { path: "/restoranlar", element: <RestaurantsPage /> },
  { path: "/restaurants", element: <RestaurantsPage /> },
  { path: "/restaurant/:id", element: <RestaurantDetail /> },
  { path: "/restaurant-apply", element: <RestaurantApplyPage /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "/admin/application/:id", element: <ApplicationDetail /> },
  { path: "/articles", element: <ArticlesPage /> },
  { path: "/article/:id", element: <ArticleDetail /> },
  { path: "/hotel-apply", element: <HotelApplyPage /> },
  { path: "/accommodations", element: <AccommodationsPage /> },
  { path: "/accommodation/:id", element: <AccommodationDetail /> },
  { path: "/gold-apply", element: <GoldApplyPage /> },
  { path: "/guides/karadeniz-yayla-rehberi", element: <BlackSeaGuide /> },
  { path: "/guides/gunubirlik-kacamaklar", element: <DayTripsGuide /> },
  { path: "/istanbul-sss", element: <IstanbulFaq /> },
  { path: "/kapadokya-sss", element: <KapadokyaFaq /> },
  { path: "/antalya-sss", element: <AntalyaFaq /> },
  { path: "/izmir-sss", element: <IzmirFaq /> },
  { path: "/mardin-sss", element: <MardinFaq /> },
  { path: "/trabzon-sss", element: <TrabzonFaq /> },
  { path: "/sakarya-sss", element: <SakarayaFaq /> },
  { path: "/kocaeli-sss", element: <KocaeliFaq /> },
  { path: "/bolu-sss", element: <BoluFaq /> },
  { path: "/gaziantep-sss", element: <GaziantepFaq /> },
  { path: "/duyurular", element: <AnnouncementsPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
